import React from 'react'
import { PencilSimpleIcon, SparkleIcon, TrashIcon } from '@phosphor-icons/react'
import { useDispatch } from 'react-redux'
import { deleteWorksheet } from '../../../store/actions'
import { useModal, MODALS } from '../../modals'
import { ScoopButton, ScoopMenu, ScoopMenuItem, ScoopMenuDivider } from '../../ui'
import styles from './WorksheetEdit.module.scss'

export default function WorksheetEdit({ isMenuOpen, setIsMenuOpen, title, id }) {
    const [anchorEl, setAnchorEl] = React.useState(null)
    const dispatch = useDispatch()
    const deleteModal = useModal(MODALS.COMMON.DELETE)

    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setIsMenuOpen(true)
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setIsMenuOpen(false)
        setAnchorEl(null)
    }

    const handleDelete = () => {
        dispatch(deleteWorksheet(id))
        setIsMenuOpen(false)
        setAnchorEl(null)
    }

    const handleDeleteClick = () => {
        handleClose()
        deleteModal.show({
            title,
            type: 'Worksheet',
            onDelete: handleDelete,
        })
    }

    return (
        <div>
            <ScoopButton
                variant="text"
                size="sm"
                onClick={handleClick}
                aria-label="edit worksheet"
                className={styles.editButton}
            >
                <SparkleIcon size={24} weight="fill" />
            </ScoopButton>
            <ScoopMenu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                className={styles.menu}
            >
                <ScoopMenuItem
                    onClick={handleClose}
                    leftSection={<PencilSimpleIcon size={18} />}
                    primary="Edit"
                />
                <ScoopMenuDivider />
                <ScoopMenuItem
                    onClick={handleDeleteClick}
                    leftSection={<TrashIcon size={18} />}
                    primary="Delete"
                />
            </ScoopMenu>
        </div>
    )
}
